import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  template: `
  <div>
    <div v-if="!select">
      <b-button
        variant="primary"
        v-b-tooltip.hover
        title="Удалить ресурс"
        @click="onDeleteClicked()">
        <em class="fas fa-times"/>
      </b-button>
    </div>
    <div v-else>
      <b-button
        variant="primary"
        v-b-tooltip.hover
        title="Выбрать ресурс"
        @click="onSelectClicked()">
        <em class="fas fa-check"></em>
      </b-button>
    </div>
  </div>
  `,
  computed: {
    ...mapGetters({
      resourceCollection: 'training/getResources'
    }),
    select() {
      return this.params.context.componentParent.select
    }
  },
  methods: {
    onDeleteClicked() {
      this.resourceCollection.deleteResource(this.params.node.data.id)
      this.params.context.componentParent.onDelete()
    },
    onSelectClicked() {
      this.params.context.componentParent.onSelect(this.params.node.data)
    }
  }
})
